import { PartWithChildrenDto } from "#modules/parts/infra/fetchPartWithChildren.api";

export const filterPartsByName = (
  part: PartWithChildrenDto,
  searchTerm: string,
): PartWithChildrenDto => {
  if (!searchTerm.trim()) {
    return part;
  }

  const lowerSearchTerm = searchTerm.toLowerCase();

  const filterChildren = (
    children: PartWithChildrenDto["children"] | PartWithChildrenDto["children"][number]["children"],
  ): PartWithChildrenDto["children"] => {
    return children
      .map((child) => {
        const matchesName = child.name.toLowerCase().includes(lowerSearchTerm);
        const filteredChildren = "children" in child ? filterChildren(child.children) : [];

        if (matchesName || filteredChildren.length > 0) {
          return {
            ...child,
            children:
              filteredChildren.length > 0
                ? filteredChildren
                : "children" in child
                  ? child.children
                  : [],
          };
        }

        return null;
      })
      .filter((child) => child !== null);
  };

  const rootMatches = part.name.toLowerCase().includes(lowerSearchTerm);
  const filteredChildren = filterChildren(part.children);

  if (rootMatches || filteredChildren.length > 0) {
    return {
      ...part,
      children: filteredChildren.length > 0 ? filteredChildren : part.children,
    };
  }

  return part;
};
